export const Center = ({ children }) => (
  <div style={{ textAlign: "center" }}>{children}</div>
);
